import { render, staticRenderFns } from "./TrGameControlPanelButtom.vue?vue&type=template&id=755953d1&scoped=true&"
import script from "./TrGameControlPanelButtom.vue?vue&type=script&lang=js&"
export * from "./TrGameControlPanelButtom.vue?vue&type=script&lang=js&"
import style0 from "./TrGameControlPanelButtom.vue?vue&type=style&index=0&id=755953d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755953d1",
  null
  
)

export default component.exports